import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { JeevesDeliveryAddressesService, JeevesDeliveryAddressStepComponent } from 'gung-standard-jeeves';
import { SelectedCustomerService } from 'gung-standard';

@Component({
    selector: 'ref-capstone-delivery-address-step',
    templateUrl: './capstone-delivery-address-step.component.html',
    styleUrls: ['./capstone-delivery-address-step.component.scss'],
    standalone: false
})
export class CapstoneDeliveryAddressStepComponent extends JeevesDeliveryAddressStepComponent implements OnInit {
  public formOh: FormGroup;

  constructor(
    protected formBuilder: FormBuilder,
    protected selectedCustomerService: SelectedCustomerService,
    protected jeevesDeliveryAddressesService: JeevesDeliveryAddressesService
  ) {
    super(formBuilder, selectedCustomerService, jeevesDeliveryAddressesService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected initForm() {
    super.initForm();

    this.formOh = this.formBuilder.group({
      edit: this.formBuilder.control(this.checkout.extra.oh.edit || '')
    });
  }

  protected assignAddressValues() {
    super.assignAddressValues();

    const rawformOhData = this.formOh.getRawValue();

    this.checkout.extra.oh = {
      ...this.checkout.extra.oh,
      ...rawformOhData
    };
  }
}
